import React from "react";
import { useTranslation } from "react-i18next";

export const Environment = () => {
  const {t} = useTranslation()
  return(
    <>
      <div className="contentBox" style={{padding: "100px 0 120px 0"}}>
        <div>
          <h3>{t("ethical_environment_1")}</h3>

          <p>
            {t("ethical_environment_2")}
          </p>
          <div>
            <p>
              <strong>1. {t("ethical_environment_3")}</strong><br/>
              {t("ethical_environment_4")}
            </p>
            <p>
              <strong>2. {t("ethical_environment_5")}</strong><br/>
              {t("ethical_environment_6")}
            </p>
            <p>
              <strong>3. {t("ethical_environment_7")}</strong><br/>
              {t("ethical_environment_8")}
            </p>
            <p>
              <strong>4. {t("ethical_environment_9")}</strong><br/>
              {t("ethical_environment_10")}
            </p>
            <p>
              <strong>5. {t("ethical_environment_11")}</strong><br/>
              {t("ethical_environment_12")}
            </p>

            <p style={{textAlign: 'center'}}>
              {t("ethical_environment_13")}
            </p>
            <span>
                    {t("greetings_content_5")} <span>{t("greetings_content_6")}</span>
                    </span>
          </div>
        </div>
      </div>
    </>
  )
}
